// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__XVZXU","productName":"Table_productName__3K6G9"};